<template>
  <div>
    <Collapse :opened="true">
      <template v-slot:title>
        <h3 class="text-blue-900 font-medium">{{ $lang.app.AGREEDS }}</h3>
      </template>
      <template v-slot:content>
        <div class="border rounded px-2">
          <div v-if="!signers.length" class="h-5"></div>
          <div class="flex justify-end my-2">
            <div class="w-3/12 text-sm text-blue-900">{{ $lang.app.SIGNED_DATE }}</div>
          </div>
          <div v-for="(signer, index) in signers" :key="index"
               class="my-2 flex items-center">
            <div class="w-9/12 flex items-center">
              <div v-if="signer.closingSign"
                   class="flex-shrink-0 w-10 h-10 border-2 border-purple-500 flex items-center justify-center mr-2"
                   :class="{'bg-purple-500': signer.signed}">
                <CheckIcon v-if="signer.signed" class="w-10 h-10 text-white"/>
              </div>
              <div v-else
                   class="flex-shrink-0 w-10 h-10 border-2 border-blue-500 flex items-center justify-center mr-2"
                   :class="{'bg-blue-500': signer.signed}">
                <CheckIcon v-if="signer.signed" class="w-10 h-10 text-white"/>
              </div>
              <div class="mr-4">
                <h6 class="text-blue-900 font-medium flex">
                  {{ signerShortName(signer) }}
                  <span v-if="signer.closingSign"
                        class="inline-block ml-1.5 w-6 h-6 flex items-center justify-center font-bold leading-none text-purple-600 bg-purple-200 rounded-full"
                        :title="$lang.app.CLOSING_SIGNER">
                    {{ $lang.app.CLOSING_SIGNER_SHORT }}
                  </span>
                </h6>
                <p class="leading-none text-blue-800 text-sm">{{ signerPosition(signer) }}</p>
              </div>
            </div>
            <div class="w-2/12">
              <p v-if="signer.signDate" class="text-sm text-blue-900">
                {{ $moment(signer.signDate).format('DD.MM.YYYY') }} <br>
                {{ $moment(signer.signDate).format('HH:mm') }}
              </p>
            </div>
            <div class="w-1/12">
              <button v-if="deletable(signer)"
                      class="inline-block ml-1.5 w-6 h-6 flex items-center justify-center font-bold leading-none text-red-600 bg-red-200 rounded-full"
                      :title="getActionTitle('RESOLUTIONS_DELETE_EMPLOYMENT')"
                      @click="deleteSigner(signer)">
                <TrashIcon class="w-4 h-4 flex-shrink-0"/>
              </button>
            </div>
          </div>
        </div>
        <div class="flex justify-end mt-1">
          <button v-if="hasAction('RESOLUTIONS_ADD_SIGNER')"
                  type="button"
                  class="flex items-center text-sm text-blue-700 bg-white hover:text-blue-800
                       font-medium rounded pl-1 text-center"
                  @click="showAddSignersModal = true">
            <PlusSmIcon class="w-5 h-5 mr-1"/>{{ getActionTitle('RESOLUTIONS_ADD_SIGNER') }}</button>
        </div>
      </template>
    </Collapse>

    <AddSignersModal v-if="showAddSignersModal"
                     :resolution="resolution"
                     :user-resolution-role="userResolutionRole"
                     @close="showAddSignersModal = false"/>
  </div>
</template>
<script>
import {getValueByKey as executorTypesGetValueByKey} from "../../../../helpers/constants/executorTypes";
import {getValueByKey as resolutionTypesGetValueByKey} from "../../../../helpers/constants/resolutionTypes";
import AddSignersModal from "./modals/AddSignersModal";
import resolutionApi from "../../../../api/employee/resolution";
import Collapse from "../../../Collapse";

export default {
  props: {
    signers: Array,
    resolution: Object,
    userResolutionRole: String,
  },
  components: {
    AddSignersModal,
    Collapse,
  },
  data() {
    return {
      showAddSignersModal: false,
    }
  },
  methods: {
    executorTypesGetValueByKey,
    resolutionTypesGetValueByKey,
    signerShortName(signer) {
      return signer.employment.surname + ' ' +
          signer.employment.name[0] + '.' +
          (signer.employment.patronymic ? signer.employment.patronymic[0] : '') + '.'
    },
    signerPosition(signer) {
      return this.$lang.$translate({
        ru: signer.employment.position.nameRu,
        kg: signer.employment.position.nameKg
      }) + ' | ' + this.$lang.$translate({
        ru: signer.employment.position.department.nameRu,
        kg: signer.employment.position.department.nameKg
      })
    },
    hasAction(action) {
      return this.resolution.actions && this.resolution.actions.some(a => a.constName === action)
    },
    getActionTitle(action) {
      return this.resolution.actions.find(a => a.constName === action)?.name
    },
    deletable(signer) {
      if(
          this.hasAction('RESOLUTIONS_DELETE_EMPLOYMENT')
          && signer.type === executorTypesGetValueByKey('SIGNER')
      ) {
        return !(this.userResolutionRole === 'ROLE_HEAD_OF_DEPARTMENT'
            && this.$store.getters.getCurrentUser.employment?.position?.department?.id !== signer.departmentId);
      }
      return false
    },
    deleteSigner(signer) {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_DELETE,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          resolutionApi.deleteEmployee(this.resolution.id, signer.id)
              .then(() => {
                this.$emit('close')
                this.$emitter.emit('refresh-resolution', {reload: false})
                this.$emitter.emit('refresh-application', {reload: false})
                this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
              })
              .catch(error => {
                this.$snotify.error(error)
              })
        }
      })
    }
  },
}
</script>